import mapKnownValues from "@/utils/mapKnownValues";

export type StationOCPPLogsItemResponse = {
  action: string;
  message: string;
  stationId: string;
  stationSerial: string;
  clusterName: string;
  clusterId: string;
  sender: string;
  chargieId: string;
  transactionId: string;
  userId: string;
  createdAt: string; // Date
};

export default class StationOCPPLogsItem {
  action = "";
  message = "";
  stationId = "";
  stationSerial = "";
  clusterName = "";
  clusterId = "";
  sender = "";
  chargieId = "";
  transactionId = "";
  userId = "";
  createdAt = new Date();

  constructor(params: Partial<StationOCPPLogsItem>) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: StationOCPPLogsItemResponse) {
    return new StationOCPPLogsItem({
      ...response,
      createdAt: new Date(response.createdAt)
    });
  }
}
